<template>
    <v-container class="email-verification-init" fluid>
        <HkiaraceBannerFrame :label="$t('email_verify_init.title')">
            <v-row class="email-verification-init-content">
                <v-col>
                    <v-row class="email-verification-init-content mb-3">
                        <v-col>
                            {{$t('email_verify_init.content')}}
                        </v-col>
                    </v-row>
                    <v-row class="email-verification-init-resend-btn mb-3">
                        <v-col cols="6">
                            <v-btn color="primary"
                                   @click="resendVerificationEmail"
                                   :disabled="resendTimeout !== 0">
                                {{$t('email_verify_init.resend')}} {{resendTimeout !== 0 ? '('+ resendTimeout.toString() +')' : ''}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="email-verification-init-back-btn mb-3">
                        <v-col cols="6">
                            <v-btn color="primary"
                                   @click="back()">{{$t('back')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </HkiaraceBannerFrame>
    </v-container>
</template>

<script>
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";

    export default {
        name: 'EmailVerificationInit',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                resendTimeout: 0,
                resendTimeoutInterval: null,
            };
        },
        mounted() {
            this.resendVerificationEmail();
        },
        methods: {
            resendVerificationEmail() {
                this.$callAPI('hkiarace/resend_email_verification/', {}, function (response) {
                    let v = this;
                    this.resendTimeout = 60;
                    this.resendTimeoutInterval = setInterval(function () {
                        v.resendTimeout -= 1;

                        if (v.resendTimeout === 0) {
                            clearInterval(v.resendTimeoutInterval);
                            v.resendTimeoutInterval = null;
                        }
                    }, 1000);
                })
            },
            back() {
                this.$router.back();
            },
        },
    }
</script>


<style lang="less">
    .email-verification-init {
        .email-verification-init-content {
            text-align: left;
        }
    }
</style>